import React from "react";
import Avatar from "@mui/material/Avatar";
import Link from "next/link";
import { CPagesPath } from "shared/models/const/pages-path";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

const Icons: any = {
  Instagram: "/icons/instagram_icon_gray.svg",
  WhatsApp: "/icons/whatsapp_icon_gray.svg",
  Twitter: "/icons/x_icon_gray.svg",
  Facebook: "/icons/facebook_icon_gray.svg",
};
const genUrl = (red: any, value: string) => {
  if (red == "WhatsApp") {
    return `https://wa.me/1${value}?text=Me+interesa+hacer+negorcios`;
  } else {
    return value;
  }
};
function AgentCardLarge(props: any) {
  return (
    <Link href={CPagesPath.es.agent_detail({ name: props.name, id: props.id })}>
      <Card>
        <CardImg src={props.picture} variant="square" alt={props.name} />
        <CardContentDetail>
          <AgentName>{props.name}</AgentName>
          <CarContainerDetail>
            <CarDetailItem>
              <ItemLabel>Teléfono</ItemLabel>
              <ItemRef
                passHref
                href={
                  "tel:" + props.mobile ?? props.phone ?? props.phone2 ?? "-"
                }
              >
                <a>{props.mobile ?? props.phone ?? props.phone2 ?? "-"}</a>
              </ItemRef>
            </CarDetailItem>
            <CarDetailItem>
              <ItemLabel>Correo</ItemLabel>
              <ItemRef passHref href={"mailto:" + props.email}>
                <a>{props.email}</a>
              </ItemRef>
            </CarDetailItem>
          </CarContainerDetail>

          <CardContentSocialNetwork>
            {props.social_networks.map((sn: any, i: any) => (
              <Link
                href={genUrl(sn.name, sn.address)}
                target="_blank"
                passHref
                key={i}
              >
                <a>
                  <img
                    src={Icons[sn.name]}
                    alt={`${Icons[sn.name]} Icon`}
                    width={30}
                    height={30}
                  />
                </a>
              </Link>
            ))}
          </CardContentSocialNetwork>
        </CardContentDetail>
      </Card>
    </Link>
  );
}

export default AgentCardLarge;

const Card = styled.a`
  width: 100%;
  max-width: 290px;
  border-radius: 15px;
  background-color: var(--color-brand-bg-secondary);
  overflow: hidden;
  display: inline-block;
  min-height: 415px;
  max-height: 415px;
  @media screen and (max-width: 500px) {
  }
`;
const CardImg = styled(Avatar)`
  width: 100%;
  height: 200px;
  object-fit: contain;
`;

const CardContentDetail = styled.div`
  padding: 20px 25px;
`;
const AgentName = styled.h3`
  font-size: 1.163rem;
  font-weight: 700;
  text-align: left;
  color: var(--color-brand-blue-main);
`;

const CarContainerDetail = styled.ul`
  width: 100%;
  list-style: none;
`;
const CarDetailItem = styled.li`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  * {
    color: var(--color-brand-grey-main) !important;
  }
`;

const GeneryItemStyles = css`
  color: var(--color-brand-grey-main) !important;
  line-height: 20px;
`;
const ItemLabel = styled.span`
  ${GeneryItemStyles}
  font-weight: 700;
  font-size: 0.9375rem;
  &::after {
    content: ":";
  }
`;
const ItemInfo = styled.span`
  ${GeneryItemStyles}
  font-weight: 400;
  font-size: 0.875rem;
`;
const ItemRef = styled(Link)`
  ${GeneryItemStyles}
  font-weight: 500;
  font-size: 0.835rem;
  a {
    color: var(--color-brand-grey-main) !important;
  }
`;

const CardContentSocialNetwork = styled.div`
  margin-top: 15px;
  display: flex;
  align-items: center;
  img {
    margin-right: 10px;
  }
`;
